import { usePropertyCurrentPlattedLots } from '../../../../queries/PropertyFields/NonRentalLandFields';
import { NumberBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface PlattedLotsCurrentProps {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const PlattedLotsCurrent: React.FC<PlattedLotsCurrentProps> = ({ propertyGuid, required, isReview = false }) => {
    const label = 'Current number of platted lots';
    const [currentPlattedLots, set_currentPlattedLots] = usePropertyCurrentPlattedLots(propertyGuid);

    const handleCurrentPlattedLots = (newvalue: number) => {
        const result = Number(newvalue) || undefined;
        set_currentPlattedLots(result);
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={currentPlattedLots}
                />
            ) : (
                <NumberBox
                    id='currentPlattedLots'
                    value={currentPlattedLots}
                    onChange={handleCurrentPlattedLots}
                    label={label}
                    required={required}
                    width='220px'
                />
            )}
        </>
    );
};
